<template>
  <div class="checkbox-input-wrapper" :class="col ? `col-lg-${col}` : ''">
    <label class="custom-checkbox" :class="{ disabled: disabled }">
      <input
        type="checkbox"
        :checked="value"
        @change="updateValue($event.target.checked)"
        :disabled="disabled"
        :readonly="readonly"
      />
      <span class="checkbox-box">
        <i v-if="value" class="fas fa-check"></i>
      </span>
      <span v-if="label" class="checkbox-label">{{ label }}</span>
      <span class="text-danger" v-if="required">*</span>
    </label>
  </div>
</template>

<script>
export default {
  name: "BaseCheckboxInput",

  props: {
    // ====== Start:: General Inputs Props ====== //
    col: {
      required: false,
      type: String,
    },
    value: {
      required: true,
    },
    color: {
      required: false,
      type: String,
      default: "#2390C6",
    },
    label: {
      required: false,
      type: String,
    },
    required: {
      required: false,
      type: Boolean,
      default: false,
    },
    readonly: {
      required: false,
      type: Boolean,
      default: false,
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    // ====== End:: General Inputs Props ====== //
  },

  methods: {
    updateValue(e) {
      this.$emit("input", e);
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox-input-wrapper {
  display: flex;
  align-items: center;
  padding: 0;
  margin: 0;

  .custom-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    gap: 10px;

    &.disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    input[type="checkbox"] {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }

    .checkbox-box {
      width: 20px;
      height: 20px;
      border: 2px solid #2390c6;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #fff;
      transition: all 0.3s ease;
      flex-shrink: 0;

      i {
        color: #fff;
        font-size: 12px;
        opacity: 0;
        transform: scale(0);
        transition: all 0.2s ease;
      }
    }

    input[type="checkbox"]:checked + .checkbox-box {
      background: #2390c6;
      border-color: #2390c6;

      i {
        opacity: 1;
        transform: scale(1);
      }
    }

    input[type="checkbox"]:focus + .checkbox-box {
      box-shadow: 0 0 0 3px rgba(35, 144, 198, 0.2);
    }

    &:hover:not(.disabled) .checkbox-box {
      border-color: #1c7aa8;
    }

    .checkbox-label {
      font-size: 14px;
      color: #333;
      line-height: 1.5;
    }

    .text-danger {
      color: #dc3545;
      margin-left: 4px;
    }
  }
}
</style>
